import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllProperties = async (params: any) => {
  const url = endpoints.PROPERTY;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getPropertyById = async (id: number) => {
  const url = endpoints.PROPERTY + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createProperty = async (params: any) => {
  const url = endpoints.PROPERTY;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateProperty = async (params: any) => {
  const url = endpoints.PROPERTY + "/" + params.id;

  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteProperty = async (id: number) => {
  const url = endpoints.PROPERTY + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const addPhoto = async (params: any) => {
  const url = endpoints.PROPERTY + "/photo";

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deletePhoto = async (id: number) => {
  const url = endpoints.PROPERTY + "/photo/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const services = {
  getAllProperties,
  createProperty,
  updateProperty,
  deleteProperty,
  getPropertyById,
  addPhoto,
  deletePhoto
};

export default services;
